import { Button, Modal, Row } from "antd";
import React, { useState } from "react";
import styles from "./styles.module.css";
import ERC0721 from "../../abis/ERC721.json";
import ERC1155 from "../../abis/ERC1155.json";
import { ethers } from "ethers";
import { useWeb3React } from "@web3-react/core";

const ConfirmMigrate = ({ open, setOpen, selectedNft }) => {
  const dos_punks_1155 = "0x495f947276749Ce646f68AC8c248420045cb7b5e";
  // still need ot replace this for main net
  const dos_punks_0721 = "0x0Aa480688025A018EBA2FE8474D5Ca545de8e9a0";
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { account, library, chainId } = useWeb3React();
  const success = () => {
    Modal.success({
      content: "Migration Successful!",
    });
  };
  const error = () => {
    Modal.error({
      title: "Wrong Network",
      content: "You are not connected to mainnet!",
    });
    setConfirmLoading(false);
    setOpen(false);
  };
  const handleMigrationSelected = async (event) => {
    console.log("migrate selected");
    setConfirmLoading(true);
    console.log({ selectedNft });
    const idsToMigrate = selectedNft.map((x) => x.tokenId);
    if (library && chainId !== 1) {
      error();
      // Handle the error or display a message to the user
      return;
    }
    try {
      const contract_1155 = new ethers.Contract(
        dos_punks_1155,
        ERC1155,
        library.getSigner()
      );
      const contract_0721 = new ethers.Contract(
        dos_punks_0721,
        ERC0721,
        library.getSigner()
      );
      const res = await contract_1155.isApprovedForAll(account, dos_punks_0721);

      // var signer = provider.getSigner();
      // var contract_1155_with_signer = contract_1155.connect(signer);
      // var contract_0721_with_signer = contract_0721.connect(signer);

      if (!res) {
        const transaction = await contract_1155.setApprovalForAll(
          dos_punks_0721,
          true
        );
      }

      const resBatch = await contract_0721.migrateBatch(idsToMigrate);
      success();
    } catch (error) {
      error();
    } finally {
      setConfirmLoading(false);
      setOpen(false);
    
    }
  };
  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <Modal
      open={open}
      title={"Migration"}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      footer={false}
    >
      <Row>
        <p>Are you ready to migrate your DOS Punk? </p>
      </Row>
      <Row className={styles.buttonRow}>
        <Button className={styles.cancel} onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          className={styles.button}
          loading={confirmLoading}
          onClick={handleMigrationSelected}
        >
          Migrate
        </Button>
      </Row>
    </Modal>
  );
};

export default ConfirmMigrate;
